<template>
  <fh-container>
    <v-card-title
      >Configuración de variedades<v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px" persistent>
        <template v-slot:activator="{ on, attrs }">
          <v-col class="py-0">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Nueva variedad
            </v-btn>
          </v-col>
        </template>
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-autocomplete
                      v-model="editedVariedad.cultivo.idCultivo"
                      :items="listaCultivos"
                      item-text="nombre"
                      item-value="idCultivo"
                      outlined
                      label="Cultivo"
                      :rules="completeRules"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedVariedad.nombre"
                      label="Nombre"
                      :rules="commonRules"
                      :counter="nombreLength"
                      outlined
                      autofocus
                      ref="Variedadref"
                    ></v-text-field>
                  </v-col>
                  <v-col> </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-text>
            <v-row class="text-center">
              <v-col class="py-0">
                <v-btn color="black" text @click="close" class="">
                  Cancelar
                </v-btn>
              </v-col>
              <v-col class="py-0">
                <v-btn color="primary" text @click="save"> Guardar </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-row>
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="listaVariedad"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-5" @click="editVariedad(item)">
              fa-pen
            </v-icon>
            <v-icon small @click="deleteVariedad(item)" color="error">
              fa-trash
            </v-icon>
          </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5 text-break"
              >¿Está seguro que quiere eliminar la variedad
              seleccionada?</v-card-title
            >
            <v-card-text class="text-center text-h5 red--text">{{
              editedVariedad.cultivoVariedad
            }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="black" text @click="closeDelete">Cancelar</v-btn>
              <v-btn color="error" text @click="deleteVariedadConfirm"
                >Eliminar</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-row>
  </fh-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FhContainer from "@/components/FhContainer";
import FhCard from "@/components/FhCard";
import ValoresRepository from "@/services/ValoresRepository";
export default {
  name: "AdminAgroVariedades",
  components: { FhCard, FhContainer },
  data() {
    return {
      // dialog flags
      dialog: false,
      dialogDelete: false,
      valid: false,
      saveDisabled: false,
      nombreLength: 30,
      commonRules: [
        (v) => !!v || "Campo obligatorio",
        (v) =>
          !v ||
          v.length <= this.nombreLength ||
          `No debe superar ${this.nombreLength} caracteres`,
      ],
      completeRules: [(v) => !!v || "Campo obligatorio"],
      editedIndex: -1,
      editedVariedad: {
        idVariedad: 0,
        nombre: "",
        cultivo: {
          idCultivo: 0,
        },
      },
      defaultVariedad: {
        idVariedad: 0,
        nombre: "",
        cultivo: {
          idCultivo: 0,
        },
      },
      headers: [
        { text: "Cultivo", value: "cultivo.nombre" },
        { text: "Nombre", value: "nombre" },
        { text: "Acciones", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapState("variedades", ["listaVariedad"]),
    ...mapState("cultivos", ["listaCultivos"]),
    formTitle() {
      return this.editedIndex === -1 ? "Nueva variedad" : "Editar variedad";
    },
  },
  methods: {
    ...mapActions("variedades", ["fetchListaVariedad", "clearListaVariedades"]),
    ...mapActions("cultivos", ["fetchListaCultivos"]),
    // Metodos de Variedades
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedVariedad = Object.assign({}, this.defaultVariedad);
        this.editedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedVariedad = Object.assign({}, this.defaultVariedad);
        this.editedIndex = -1;
      });
    },
    editVariedad(variedad) {
      this.editedIndex = this.listaVariedad.indexOf(variedad);
      this.editedVariedad = Object.assign({}, variedad);
      this.dialog = true;
    },
    deleteVariedad(variedad) {
      this.editedIndex = this.listaVariedad.indexOf(variedad);
      this.editedVariedad = Object.assign({}, variedad);
      this.dialogDelete = true;
    },
    async deleteVariedadConfirm() {
      await ValoresRepository.debajaVariedad(this.editedVariedad.idVariedad);
      this.closeDelete();
    },
    async save() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          if (this.editedIndex > -1) {
            await ValoresRepository.actualizarVariedad(
              this.editedVariedad.idVariedad,
              this.editedVariedad.cultivo.idCultivo,
              this.editedVariedad.nombre
            );
          } else {
            await ValoresRepository.crearVariedad(
              this.editedVariedad.cultivo.idCultivo,
              this.editedVariedad.nombre
            );
          }
          this.editedVariedad = Object.assign({}, this.defaultVariedad);
          this.editedIndex = -1;

          this.clearListaVariedades();
          await this.fetchListaVariedad();
        }
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.close();
    },
  },
  async created() {
    await this.fetchListaVariedad();
    await this.fetchListaCultivos();
  },
};
</script>

<style>
</style>